/* @flow */

import type Moment from 'moment';
import { mutateAsync } from 'redux-query';
import { EventTypes } from 'redux-segment';

import * as t from './actionTypes';
import * as q from './queries';
import type { CreateTripRequestOptions } from './queries';
import type { TripContact, UseCase, Review } from '../../data/TripRequests';
import type { PartnerID } from '../../data/Partners';

export function resetNewTripRequest(created?: boolean) {
  return {
    type: t.RESET_NEW_TRIP_REQUEST,
    created,
  };
}

export function resetCreatedNewTripRequest() {
  return {
    type: t.RESET_CREATED_NEW_TRIP_REQUEST,
  };
}

export function setNewTripRequestContacts(contacts: TripContact[]) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_CONTACTS,
    contacts,
  };
}

export function setNewTripRequestUseCase(useCase: UseCase) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_USE_CASE,
    useCase,
  };
}

export function setNewTripRequestPartnerSession(partner: PartnerID, sessionId: string) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_PARTNER_SESSION,
    partner,
    sessionId,
  };
}

export function setNewTripRequestDay(date: Moment) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_DAY,
    day: date,
  };
}

export function setNewTripRequestTime(start: Moment, end: Moment) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_TIME,
    fromTime: start,
    toTime: end,
  };
}
export function setNewTripRequestOnDemand(onDemand: boolean, label: ?string) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_ON_DEMAND,
    onDemand,
    label,
  };
}

export function setNewTripRequestDescription(description: string) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_DESCRIPTION,
    description,
  };
}

export function setNewTripRequestPaymentSourceId(paymentSourceId: string) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_PAYMENT_SOURCE_ID,
    paymentSourceId,
  };
}

export function setNewTripRequestProduct(product: string) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_PRODUCT,
    product,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Product Clicked',
          properties: {
            product_id: product,
            name: product,
          },
        },
      },
    },
  };
}

export function setNewTripRequestPromoCode(promoCode: Object) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_PROMO_CODE,
    promoCode,
  };
}

export function setNewTripRequestQueryString(queryString: string) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_QUERY_STRING,
    queryString,
  };
}

export function setNewTripRequestOriginId(originId: string) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_ORIGIN_ID,
    originId,
  };
}

export function setNewTripRequestDestinationId(destinationId: string) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_DESTINATION_ID,
    destinationId,
  };
}

export function setNewTripRequestFareEstimateId(fareEstimateId: string) {
  return {
    type: t.SET_NEW_TRIP_REQUEST_FARE_ESTIMATE_ID,
    fareEstimateId,
  };
}

export function addNewTripRequestPhoto(url: string) {
  return {
    type: t.ADD_NEW_TRIP_REQUEST_PHOTO,
    url,
  };
}

export function removeNewTripRequestPhoto(url: string) {
  return {
    type: t.REMOVE_NEW_TRIP_REQUEST_PHOTO,
    url,
  };
}

export function createTripRequest(options: CreateTripRequestOptions) {
  return mutateAsync(q.createTripRequest(options));
}

export function updateTripRequest(tripRequestId: string, changes: CreateTripRequestOptions) {
  return mutateAsync(q.updateTripRequest(tripRequestId, changes));
}

export function getTripRequestById(tripRequestId: string) {
  return mutateAsync(q.getTripRequestById(tripRequestId));
}

export function reviewTripRequest(tripRequestId: string, review: Review) {
  return mutateAsync(q.reviewTripRequest(tripRequestId, review));
}

export function cancelTripRequest(tripRequestId: string, reason: string) {
  return mutateAsync(q.cancelTripRequest(tripRequestId, reason));
}



// WEBPACK FOOTER //
// ./src/redux/trip-requests/actions.js